<template>
    <group-details :groupId="props.groupId">
        <div class="col-span-12 lg:col-span-6">
            <page-header class="mb-2 md:mb-2">Collections</page-header>

            <div v-if="loading && !list.length" class="text-center py-10">
                <vx-icon-loading class="w-9 h-9 animate-loading-spin"></vx-icon-loading>
            </div>

            <template v-else-if="!loading && list.length === 0">
                <vx-box color="info" class="flex flex-col px-8 py-20 gap-6 items-center text-xl text-slate-500">
                    No collections yet.
                </vx-box>
            </template>
            <template v-else>
                <vx-table v-if="list.length" class="xl:grid-cols-2 mt-0" rowBreakpoint="xl">
                    <vx-table-row isHeader>
                        <div class="xl:col-span-2">
                            Name
                        </div>
                    </vx-table-row>
                    <group-collection-row v-for="(item, index) in list"
                        v-model="list[index]"
                        :key="item.id"></group-collection-row>
                </vx-table>
            </template>
        </div>
    </group-details>
</template>

<script setup>
import GroupDetails from '../GroupDetails.vue';
import { VxBox, VxIconLoading, VxTable, VxTableRow } from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import GroupCollectionRow from './GroupCollectionRow.vue';
import { useCursorPagination } from '~/composables/useCursorPagination';
import { groupsClient} from '~/services';
import { onMounted } from 'vue';

const teamId = Spark.state.currentTeam.id;
const { list, loading, fetchRecords } = useCursorPagination();

const props = defineProps({
    groupId: {
        type: String,
        required: true,
    },
});

onMounted(() => {
    fetchRecords(groupsClient.getGroupGroupCollections({ teamId }, props.groupId));
});
</script>
